import React, { FC } from 'react';
import classes from './SideDrawer.module.scss';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'gatsby-link';
import Can from '../../../context/can';
import GatsbyImage from 'gatsby-image';
import useGetLogo from '../../../../hooks/useGetLogo';
import { navItems } from './navItems';
import CustomIcon from './customIcon/CustomIcon';

export interface ISideDrawer {
  modalOpen: boolean;
  onClick: () => void;
}

const SideDrawer: FC<ISideDrawer> = ({ modalOpen, onClick }) => {
  const { logo } = useGetLogo();

  return (
    <>
      <aside className={[classes.drawerRoot, modalOpen ? classes.in : classes.out].join(' ')}>
        <Link to="/dashboard" onClick={onClick}>
          <GatsbyImage fluid={logo} className={classes.logo} />
        </Link>
        <div className={classes.divider} />
        <Container className={['p-0 m-0', classes.navbarContainer].join(' ')}>
          <Navbar className={['pt-0', classes.navbar].join(' ')}>
            <Nav className="m-auto flex-column" variant="pills">
              {navItems.map((item: any, index) => (
                <Can
                  key={index}
                  perform={item.permission}
                  yes={() => (
                    <Link to={item.to} onClick={onClick} className="mt-2 mb-2 text-center flex-column text-dark">
                      {item.customIcon ? <CustomIcon moduleName={item.displayText} /> : <FontAwesomeIcon icon={item.icon} />}
                      <p>{item.displayText}</p>
                    </Link>
                  )}
                  no={() => <></>}
                />
              ))}
            </Nav>
          </Navbar>
        </Container>
      </aside>
      <div className={[classes.backdrop, modalOpen ? classes.dropIn : classes.dropOut].join(' ')} onClick={onClick} />
    </>
  );
};

export default SideDrawer;
